import React from 'react'
import PropTypes from 'prop-types'
import {
    Row,
    Container,
    Button
} from 'reactstrap'
import { connect } from 'react-redux'
import { select } from '@rematch/select'

import PageTitle from 'components/PageTitle'
import SubNavigation from 'components/SubNavigation'
import Roles from 'features/auth/Roles'
import View from 'components/View'
import userManager from 'services/UserManager'

import TenantsList from './components/TenantsList'
import TenantsForm from './components/TenantsForm'

import './TenantsIndex.scss'

class TenantsIndex extends React.Component {

    static propTypes = {
        roles: PropTypes.array
    }

    constructor(props) {
        super(props)
        this.state = {
            showForm: false,
            editingTenant: null
        }
    }

    handleAddNew = () => {
        this.setState({
            showForm: true,
            editingTenant: null
        })
    }

    handleEdit = tenant => {
        this.setState({
            showForm: true,
            editingTenant: tenant
        })
    }

    handleCancel = () => {
        this.setState({
            showForm: false,
            editingTenant: null
        })
    }

    handleLogout = () => {
        // Clear session storage
        sessionStorage.removeItem('ARO_ADMIN_SID')
        // Redirect to the identity provider logout page
        userManager.signoutRedirect()
    }

    render() {
        const {
            roles
        } = this.props

        const {
            showForm,
            editingTenant
        } = this.state

        if (roles && roles.indexOf(Roles.SuperAdmin) < 0) {
            return (
                <React.Fragment>
                    <SubNavigation />
                    <View>
                        <h3>
                            De tenants functionaliteit is alleen beschikbaar voor systeem admins
                        </h3>
                        <Button color="primary" onClick={ this.handleLogout } className="mt-3">
                            Uitloggen
                        </Button>
                    </View>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <SubNavigation />
                <View>
                    <Container>
                        <Row className="d-flex justify-content-between align-items-center mb-4">
                            <PageTitle>Tenants beheren</PageTitle>
                            <div>
                                {!showForm && (
                                    <Button color="primary" onClick={ this.handleAddNew }>
                                        Nieuwe tenant toevoegen
                                    </Button>
                                )}
                                <Button color="primary" onClick={ this.handleLogout } className="ml-2">
                                    Uitloggen
                                </Button>
                            </div>
                        </Row>

                        {showForm ? (
                            <TenantsForm 
                                tenant= { editingTenant } 
                                onCancel= { this.handleCancel }
                            />
                        ) : (
                            <TenantsList 
                                onEdit= { this.handleEdit }
                            />
                        )}
                    </Container>
                </View>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        roles: select.profile.roles(state)
    }
}

export default connect(mapStateToProps, null)(TenantsIndex)